/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, OnInit } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { FeedbackEnrichedAnswer, FeedbackRecipient, IncludedFeedbackQuestion, Organization } from '@app/app/shared/models';

@Component({
  selector: 'ptl-feedback-providers-question-answer-text',
  templateUrl: './question-answer-text.component.html',
  styleUrls: ['./question-answer-text.component.scss'],
})
export class QuestionAnswerTextComponent implements OnInit {
  @Input() question: IncludedFeedbackQuestion;

  @Input() answers: FeedbackEnrichedAnswer[];

  @Input() feedbackRecipient?: FeedbackRecipient;

  @Input() language: string;

  @Input() organization: Organization;

  answer: FeedbackEnrichedAnswer;
  title: string;
  feedbackProviderResponsesCount: number;

  ngOnInit(): void {
    if (this.question) {
      this.title = this.getInstruction();
      this.answer = this.getCurrentAnswer();
      this.feedbackProviderResponsesCount = this.getFeedbackProviderResponsesCount();
    }
  }

  private getFeedbackProviderResponsesCount(): number {
    return this.answer?.answers?.length ?? 0;
  }

  private getInstruction(): string {
    return LanguageCodeHelper.getDataByUserLanguageCode(this.question.question.instructions, this.organization, this.language)?.value ?? '';
  }

  private getCurrentAnswer(): FeedbackEnrichedAnswer {
    return this.answers.find((answer) => answer.questionUid === this.question.question.uid);
  }
}
